import './styles.scss';
import React from 'react';
import {Card, Col, Collapse, Descriptions, Row, Statistic, Typography} from "antd";
import {IOpportunity} from "../../../api/Opportunity/Opportunity.types";

import moment from "moment";
import Link from '../../common/ExternalLink/ExternalLink';
import {CalendarOutlined, GroupOutlined} from "@ant-design/icons";

interface Props {
    opportunity: IOpportunity
}

function OpportunityDetails({opportunity}: Props) {
    return (
        <div className='opportunity-details'>
            <div className='opportunity-details-header'>
                <div className='top'>
                    <div className='title'>{opportunity.title}</div>
                    <div className='contracting-officer'>Internal FAMR ID: <b>{opportunity.id}</b></div>
                </div>
                <div className='description'>
                    <div>
                        <Link link={opportunity.uiLink.replace('beta.', '')} text='SAM Page' external/>
                    </div>
                </div>
            </div>
            <Row gutter={24} style={{marginBottom: 24}}>
                <Col span={8}>
                    <Card>
                        <Statistic
                            title={<div className='total-statistic'><GroupOutlined/>Type</div>}
                            value={opportunity.type}
                            valueStyle={{color: '#3f8600'}}
                            formatter={type => <Typography.Text ellipsis={true}>{type}</Typography.Text>}
                        />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card>
                        <Statistic
                            title={<div className='total-statistic'><CalendarOutlined/>Posted Date</div>}
                            value={opportunity.postedDate ? moment(opportunity.postedDate).format("MMM DD, YYYY") : "N/A"}
                            valueStyle={{color: '#3f8600'}}
                        />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card>
                        <Statistic
                            title={<div className='total-statistic'><CalendarOutlined/>Response Date Date</div>}
                            value={opportunity.responseDate ? moment(opportunity.responseDate).format("MMM DD, YYYY") : "N/A"}
                            valueStyle={{color: '#3f8600'}}
                        />
                    </Card>
                </Col>
            </Row>
            <Collapse>
                <Collapse.Panel key={1} header="Details">
                    <Descriptions size="small" bordered labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Notice ID'>
                            {opportunity.noticeId || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Solicitation Number'>
                            {opportunity.solicitationNumber || "N/A"}
                        </Descriptions.Item>
                    </Descriptions>
                </Collapse.Panel>
                <Collapse.Panel key={2} header="Related Codes">
                    <Descriptions size="small" bordered labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='NAICS'>
                            {opportunity.naics || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='PSC Code'>
                            {opportunity.pscCode || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Set Aside'>
                            {opportunity.setAside || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='PoP City/State'>
                            {opportunity.popCity}, {opportunity.popState}
                        </Descriptions.Item>
                    </Descriptions>
                </Collapse.Panel>
                <Collapse.Panel key={3} header="Contracting Officer">
                    <Descriptions size="small" bordered labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Contracting Officer Name'>
                            {opportunity.contractingOfficer || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Contracting Officer Email'>
                            {opportunity.contractingOfficerEmail || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Contracting Officer Phone'>
                            {opportunity.contractingOfficerPhone || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Agency'>
                            {opportunity.agency || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Award PIID'>
                            {opportunity.awardPiid || "N/A"}
                        </Descriptions.Item>
                    </Descriptions>
                </Collapse.Panel>
                <Collapse.Panel key={4} header="Miscellaneous">
                    <Descriptions size="small" bordered labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Attachments'>
                            {opportunity.attachments || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Archive Date'>
                            {opportunity.archiveDate ? moment(opportunity.archiveDate).format("MMM DD, YYYY") : "N/A"}
                        </Descriptions.Item>
                    </Descriptions>
                </Collapse.Panel>
            </Collapse>


        </div>
    )
}

export default OpportunityDetails;